import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SfCloseCrossLargeIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M21.28 3.22a.75.75 0 0 0-1.06 0l-7.72 7.72-7.72-7.72a.75.75 0 0 0-1.06 1.06L11.44 12l-7.72 7.72a.75.75 0 0 0 1.06 1.06l7.72-7.72 7.72 7.72a.75.75 0 0 0 1.06-1.06L13.56 12l7.72-7.72a.75.75 0 0 0 0-1.06Z"
  })
});
export default SfCloseCrossLargeIcon;